export const redirectPages = [
    {
        '/zusatzleistung': true,
    },
    {
        '/buchung-verwalten': true,
    },
    {
        '/dokumente': '/dokumente-anzeigen',
    },
    {
        '/zahlungsstatus': true,
    },
    {
        '/digitale-reiseleitung': true,
    },
    {
        '/apis': true,
    },
    {
        '/transfer': true,
    },
    {
        '/railandfly': '/zug-zum-flug',
    },
    {
        '/zug-zum-flug': true,
    },
    {
        '/reklamation': true,
    },
    {
        '/notfall-kontakt': true,
    },
    {
        '/stornierung': true,
    },
    {
        '/sitzplatzreservierung': true,
    },
    {
        '/ausfluege': true,
    },
    {
        '/zahlung': true,
    },
    {
        '/anzahlung': '/zahlung',
    },
    {
        '/restzahlung': '/zahlung',
    },
    {
        '/erstattung': '/rueckzahlung',
    },
    {
        '/gutschrift': true,
    },
    {
        '/stornierung-ausflug': '/leistung-stornieren/ausflug',
    },
    {
        '/stornierung-sitzplatz': '/leistung-stornieren/sitzplatzreservierung',
    },
    {
        '/stornierung-transfer': '/leistung-stornieren/transfer',
    },
    {
        '/stornierung-railandfly': '/leistung-stornieren/railandfly',
    },
    {
        '/flugalternativen': {
            linkOut: {
                redirectPage: '/buchung-verwalten',
                trigger: 'flightAlternativeATC',
            },
        },
    },
    {
        '/flug-aendern': {
            linkOut: {
                redirectPage: '/buchung-verwalten',
                trigger: 'flightChangeSearch',
            },
        },
    },
    {
        '/hotel-aendern': {
            linkOut: {
                redirectPage: '/buchung-verwalten',
                trigger: 'hotelChangeSearch',
            },
        },
    },
];
export default redirectPages;
